const stats = [
  { value: '10万+', label: '每日资讯更新' },
  { value: '3大', label: '核心内容板块' },
  { value: '24小时', label: '热点持续追踪' },
  { value: '全网', label: '话题聚合整理' },
];

export default function SiteIntro() {
  return (
    <section className="mx-auto max-w-7xl px-4 pb-4 md:px-8">
      <div className="overflow-hidden rounded-lg border border-background-200 bg-background-100">
        <div className="grid grid-cols-1 gap-8 p-7 md:grid-cols-2 md:p-10">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
              <i className="ri-quill-pen-line" />
              关于靠逼
            </span>
            <h2 className="mt-4 font-heading text-2xl font-black leading-snug text-foreground-950 md:text-3xl">
              一个专注娱乐动态的内容平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
              靠逼聚焦最新的娱乐新闻、影视推荐与热门话题，用清晰的结构与多元的视角，
              帮助热爱娱乐的你快速了解行业动态、发现值得一看的作品，并参与到时下最热的讨论之中。
              无论是追踪明星动态、筛选观影清单，还是围观热点话题，都能在这里找到所需。
            </p>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {stats.map((s) => (
              <div key={s.label} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <p className="font-heading text-2xl font-black text-primary-600 md:text-3xl">{s.value}</p>
                <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}